import { optionsToStrategy } from "@/common/utils/optionsToStrategy"

export const options = [
  {
    label: 'Apenas informativo',
    value: 'informational_only'
  },
  {
    label: 'Validar no consumo',
    value: 'validate_on_consumption'
  }
]

export const strategy = optionsToStrategy(options)
